<!-- =========================================================
     Short Course Admin List
========================================================= -->

<section class="ecb-x-admin-list-section">

    <div class="container-fluid">

        <div class="ecb-x-admin-list-card">

            <!-- =======================================================
       Page Header
  ======================================================== -->

            <div class="d-flex flex-column flex-lg-row
              align-items-lg-center justify-content-between
              gap-3 mb-4">

                <div>

                    <h1 class="fs-4 fw-bold text-dark mb-1">
                        VOC Courses
                    </h1>

                    <p class="text-muted small mb-0">
                        Manage Verification of Competency course information,
                        delivery details, requirements, certification and costs.
                    </p>

                </div>


                <div class="d-flex flex-column flex-sm-row gap-2">

                    <!-- Refresh -->




                    <!-- Add VOC -->

                    <button type="button" class="btn btn-primary
               d-inline-flex align-items-center
               justify-content-center gap-2" (click)="openAddVOC()">

                        <i class="bi bi-plus-lg"></i>

                        <span>
                            Add VOC
                        </span>

                    </button>

                </div>

            </div>


            <!-- =======================================================
       Table Card
  ======================================================== -->

            <div class="ecb-x-admin-voc-table-card">

                <div class="table-responsive ecb-x-admin-table-container">
                    <p-table #courseTable [value]="pagedVOCCourses" [loading]="isLoading" [scrollable]="true"
                        [tableStyle]="{
        'min-width': '1280px'
    }" styleClass="ecb-admin-table">


                        <!-- Header -->
                        <ng-template pTemplate="header">

                            <tr class="ecb-admin-table-header-row">

                                <th class="ecb-admin-table-header">
                                    VOC Code
                                </th>

                                <th class="ecb-admin-table-header">
                                    VOC Course
                                </th>

                                <th class="ecb-admin-table-header">
                                    Description
                                </th>

                                <th class="ecb-admin-table-header text-center">
                                    Status
                                </th>

                                <th class="ecb-admin-table-header ecb-admin-table-action-header">
                                    Action
                                </th>

                            </tr>

                        </ng-template>


                        <!-- Body -->
                        <ng-template pTemplate="body" let-voc>

                            <tr class="ecb-admin-table-row">


                                <!-- VOC Code -->
                                <td class="ecb-admin-table-cell">

                                    <span class="ecb-x-admin-voc-code fw-bold">
                                        {{ voc.vocCode || '-' }}
                                    </span>

                                </td>


                                <!-- VOC Course -->
                                <td class="ecb-admin-table-cell">

                                    <div class="fw-semibold text-dark">
                                        {{ voc.vocName || '-' }}
                                    </div>

                                </td>


                                <!-- Description -->
                                <td class="ecb-admin-table-cell">

                                    <div *ngIf="voc.description" class="text-muted small ecb-x-admin-voc-description">

                                        {{
                                        getShortDescription(
                                        voc.description
                                        )
                                        }}

                                    </div>

                                    <span *ngIf="!voc.description">
                                        -
                                    </span>

                                </td>


                                <!-- Status -->
                                <td class="ecb-admin-table-cell text-center">

                                    <span class="ecb-x-admin-status-badge" [class.active]="voc.isActive"
                                        [class.inactive]="!voc.isActive">

                                        {{
                                        voc.isActive
                                        ? 'Active'
                                        : 'Inactive'
                                        }}

                                    </span>

                                </td>


                                <!-- Action -->
                                <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

                                    <button type="button"
                                        class="ecb-admin-table-action-button ecb-admin-table-edit-button"
                                        title="Edit VOC" (click)="editVOC(voc)">

                                        <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>

                                    </button>

                                </td>

                            </tr>

                        </ng-template>


                        <!-- Empty -->
                        <ng-template pTemplate="emptymessage">

                            <tr class="ecb-admin-table-row">

                                <td colspan="5" class="ecb-admin-table-cell text-center py-5">

                                    <div class="ecb-x-admin-voc-empty-icon mx-auto mb-3">

                                        <i class="bi bi-folder2-open fs-4"></i>

                                    </div>

                                    <div class="fw-semibold text-dark mb-1">
                                        No VOC courses found
                                    </div>

                                    <div class="text-muted small">
                                        Add a VOC course to get started.
                                    </div>

                                </td>

                            </tr>

                        </ng-template>


                        <!-- Loading -->
                        <ng-template pTemplate="loadingbody">

                            <tr class="ecb-admin-table-row">

                                <td colspan="5" class="ecb-admin-table-cell text-center py-5">

                                    <div class="spinner-border spinner-border-sm me-2" role="status">
                                    </div>

                                    <span class="text-muted">
                                        Loading VOC courses...
                                    </span>

                                </td>

                            </tr>

                        </ng-template>

                    </p-table>

                </div>


                <!-- =====================================================
         Footer
    ====================================================== -->


                <!-- Start VOC Table Footer -->
                <div class="ecb-x-admin-voc-table-footer">

                    <div class="row align-items-center gy-3">

                        <!-- Showing Records -->
                        <div class="col-12 col-lg-4">

                            <div class="ecb-x-admin-voc-paginator-info">

                                Showing
                                {{ startRecord }}–{{ endRecord }}
                                of {{ allVOCCourses.length }} courses

                            </div>

                        </div>


                        <!-- Rows Per Page -->
                        <div class="col-12 col-lg-4">

                            <div class="ecb-x-admin-voc-paginator-size">

                                <label>
                                    Rows per page
                                </label>

                                <select class="form-select form-select-sm" [(ngModel)]="pageSize"
                                    (ngModelChange)="onVOCPageSizeChange()">

                                    <option [ngValue]="10">10</option>
                                    <option [ngValue]="20">20</option>
                                    <option [ngValue]="50">50</option>
                                    <option [ngValue]="100">100</option>

                                </select>

                            </div>

                        </div>


                        <!-- Pagination Buttons -->
                        <div class="col-12 col-lg-4">

                            <div class="ecb-x-admin-voc-paginator-navigation">

                                <!-- Previous -->
                                <button type="button" class="ecb-x-admin-voc-page-button" [disabled]="currentPage === 1"
                                    (click)="previousPage()">

                                    Previous

                                </button>


                                <!-- Page Numbers -->
                                <button type="button" *ngFor="let page of vocPageNumbers"
                                    class="ecb-x-admin-voc-page-button"
                                    [class.ecb-x-admin-voc-page-active]="currentPage === page"
                                    (click)="changeVOCPage(page)">

                                    {{ page }}

                                </button>


                                <!-- Next -->
                                <button type="button" class="ecb-x-admin-voc-page-button"
                                    [disabled]="currentPage === totalPages" (click)="nextPage()">

                                    Next

                                </button>

                            </div>

                        </div>

                    </div>

                </div>
                <!-- End VOC Table Footer -->


            </div>


            <!-- =======================================================
       Add / Edit Modal
  ======================================================== -->

            <div class="ecb-x-admin-voc-modal-overlay" *ngIf="showVOCModal">

                <div class="ecb-x-admin-voc-modal">

                    <!-- Header -->

                    <div class="ecb-x-admin-voc-modal-header
               d-flex align-items-center
               justify-content-between gap-3">

                        <div>

                            <h2 class="fs-5 fw-bold mb-1">

                                {{
                                isEditMode
                                ? 'Edit VOC Course'
                                : 'Add VOC Course'
                                }}

                            </h2>

                            <div class="small opacity-75">

                                {{
                                isEditMode
                                ? 'Update VOC course information and training details.'
                                : 'Create a new Verification of Competency course.'
                                }}

                            </div>

                        </div>


                        <button type="button" class="btn ecb-x-admin-voc-modal-close" [disabled]="isSaving"
                            (click)="closeVOCModal()">

                            <i class="bi bi-x-lg"></i>

                        </button>

                    </div>


                    <!-- Body -->

                    <div class="ecb-x-admin-voc-modal-body">

                        <!-- Loading Details -->

                        <div class="text-center py-5" *ngIf="isLoadingDetails">

                            <div class="spinner-border
                   text-primary mb-3">
                            </div>

                            <div class="text-muted">
                                Loading VOC details...
                            </div>

                        </div>


                        <ng-container *ngIf="!isLoadingDetails">

                            <!-- Error -->

                            <div class="alert alert-danger" *ngIf="formError">

                                <i class="bi bi-exclamation-circle
                     me-2">
                                </i>

                                {{ formError }}

                            </div>


                            <!-- =================================================
               Basic Information
          ================================================== -->

                            <div class="ecb-x-admin-voc-form-section">

                                <div class="mb-4">

                                    <h3 class="fs-6 fw-bold mb-1">
                                        Basic Information
                                    </h3>

                                    <div class="text-muted small">
                                        Enter the main VOC course details.
                                    </div>

                                </div>


                                <div class="row g-3">

                                    <!-- VOC Code -->

                                    <div class="col-12 col-md-4">

                                        <label class="form-label fw-semibold">

                                            VOC Code
                                            <span class="text-danger">*</span>

                                        </label>

                                        <input type="text" class="form-control" maxlength="100"
                                            [(ngModel)]="vocForm.vocCode" placeholder="e.g. VOC-EWP">

                                    </div>


                                    <!-- VOC Name -->

                                    <div class="col-12 col-md-8">

                                        <label class="form-label fw-semibold">

                                            VOC Name
                                            <span class="text-danger">*</span>

                                        </label>

                                        <input type="text" class="form-control" maxlength="250"
                                            [(ngModel)]="vocForm.vocName" placeholder="Enter VOC course name">

                                    </div>


                                    <!-- Parent Course Id -->
                                    <!-- 
                            <div class="col-12 col-md-4">

                                <label class="form-label fw-semibold">

                                    Parent Course Id

                                </label>

                                <input type="number" class="form-control" [(ngModel)]="
                    vocForm.fkParentCourseId
                  " placeholder="Optional">

                            </div> -->


                                    <!-- Cost -->

                                    <div class="col-12 col-md-4">

                                        <label class="form-label fw-semibold">

                                            Cost

                                        </label>

                                        <div class="input-group">

                                            <span class="input-group-text">
                                                $
                                            </span>

                                            <input type="number" class="form-control" min="0" step="0.01"
                                                [(ngModel)]="vocForm.cost" placeholder="0.00">

                                        </div>

                                    </div>


                                    <!-- Status -->

                                    <!-- Status -->
                                    <div class="col-12 col-md-4">

                                        <label class="form-label fw-semibold d-block">
                                            Status
                                        </label>
                                        <div class="ecb-sync-switch-wrapper">
                                            <label class="ecb-sync-switch">
                                                <input type="checkbox" [(ngModel)]="vocForm.isActive"
                                                    name="isHighRiskCourse">
                                                <span class="ecb-sync-slider"></span>
                                            </label>
                                            <span class="ecb-sync-status">{{ vocForm.isActive ? 'On' : 'Off' }}</span>
                                        </div>




                                    </div>


                                    <!-- Document Types -->

                                    <!--  <div class="col-12">

                                <label class="form-label fw-semibold">

                                    Document Types

                                </label>

                                <input type="text" class="form-control" [(ngModel)]="
                    vocForm.documentTypes
                  " placeholder="Enter document types">

                            </div> -->

                                </div>

                            </div>
                            <!-- =================================================
               Description
          ================================================== -->

                            <div class="ecb-x-admin-voc-form-section">

                                <div class="mb-3">

                                    <h3 class="fs-6 fw-bold mb-1">
                                        Description
                                    </h3>

                                    <div class="text-muted small">
                                        Add the public description of this VOC course.
                                    </div>

                                </div>


                                <p-editor [(ngModel)]="vocForm.description" [style]="{ height: '200px' }"
                                    [modules]="editorModules">
                                </p-editor>

                            </div>
                            <!-- =================================================
                Short Description
          ================================================== -->
                            <div class="ecb-x-admin-voc-form-section">

                                <div class="mb-3">

                                    <h3 class="fs-6 fw-bold mb-1">
                                        Short Description
                                    </h3>

                                    <div class="text-muted small">
                                        Add the public short description of this VOC course.
                                    </div>

                                </div>


                                <p-editor [(ngModel)]="vocForm.nShortDescription" [style]="{ height: '200px' }"
                                    [modules]="editorModules">
                                </p-editor>

                            </div>




                            <!-- =================================================
               Training Information
          ================================================== -->

                            <div class="ecb-x-admin-voc-form-section">

                                <div class="mb-4">

                                    <h3 class="fs-6 fw-bold mb-1">
                                        Training Information
                                    </h3>

                                    <div class="text-muted small">
                                        Configure delivery, location, requirements
                                        and certification details.
                                    </div>

                                </div>


                                <div class="row g-4">

                                    <!-- Delivery -->

                                    <div class="col-12 col-lg-6">

                                        <div class="ecb-x-admin-voc-editor-field
                         h-100">

                                            <label class="form-label fw-semibold">

                                                Delivery

                                            </label>



                                            <p-editor [modules]="editorModules" [(ngModel)]="
                      vocForm.delivery
                    " [style]="{
                      height: '180px'
                    }">
                                            </p-editor>

                                        </div>

                                    </div>


                                    <!-- Location -->

                                    <div class="col-12 col-lg-6">

                                        <div class="ecb-x-admin-voc-editor-field
                         h-100">

                                            <label class="form-label fw-semibold">

                                                Location

                                            </label>


                                            <input type="text" class="form-control" maxlength="50"
                                                [(ngModel)]="vocForm.location" placeholder="Enter   Location">

                                            <!--   <p-editor [modules]="editorModules" [(ngModel)]="
                      vocForm.location
                    " [style]="{
                      height: '180px'
                    }">
                                    </p-editor> -->

                                        </div>

                                    </div>


                                    <!-- Requirements -->

                                    <div class="col-12 col-lg-6">

                                        <div class="ecb-x-admin-voc-editor-field
                         h-100">

                                            <label class="form-label fw-semibold">

                                                Requisites / Requirements

                                            </label>

                                            <p-editor [modules]="editorModules" [(ngModel)]="
                      vocForm.requisitesRequirements
                    " [style]="{
                      height: '180px'
                    }">
                                            </p-editor>

                                        </div>

                                    </div>


                                    <!-- Certification -->

                                    <div class="col-12 col-lg-6">

                                        <div class="ecb-x-admin-voc-editor-field
                         h-100">

                                            <label class="form-label fw-semibold">

                                                Certification

                                            </label>

                                            <p-editor [modules]="editorModules" [(ngModel)]="
                      vocForm.certification
                    " [style]="{
                      height: '180px'
                    }">
                                            </p-editor>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </ng-container>

                    </div>


                    <!-- Footer -->

                    <div class="ecb-x-admin-voc-modal-footer
               d-flex flex-column-reverse
               flex-sm-row justify-content-end
               gap-2">

                        <button type="button" class="btn btn-light border" [disabled]="isSaving"
                            (click)="closeVOCModal()">

                            Cancel

                        </button>


                        <button type="button" class="btn btn-primary
                 d-inline-flex align-items-center
                 justify-content-center gap-2" [disabled]="
            isSaving ||
            isLoadingDetails
          " (click)="saveVOC()">

                            <span *ngIf="isSaving" class="spinner-border
                   spinner-border-sm">
                            </span>

                            <i *ngIf="!isSaving" class="bi" [ngClass]="
              isEditMode
                ? 'bi-check-lg'
                : 'bi-plus-lg'
            ">
                            </i>

                            <span>

                                {{
                                isSaving
                                ? 'Saving...'
                                : (
                                isEditMode
                                ? 'Update VOC'
                                : 'Add VOC'
                                )
                                }}

                            </span>

                        </button>

                    </div>

                </div>

            </div>

        </div>
    </div>
</section>